var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10011_7977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.80643 11.0834L2.16776 12H9.84132L9.20265 11.0834H2.80643Z",
    fill: "url(#paint0_linear_10011_7977)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92462 7.60841L2.47284 9.69284H1.92949C1.56535 9.69284 1.24888 9.49277 1.08302 9.15867C0.917154 8.82457 0.943845 8.44218 1.15546 8.13568L4.81113 2.85512V10.6094H5.69764V0L0.434816 7.6025C0.031597 8.18397 -0.0217844 8.94087 0.29469 9.57753C0.611165 10.2142 1.23744 10.6094 1.92949 10.6094H3.92462V7.60841Z",
    fill: "url(#paint1_linear_10011_7977)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07403 7.60841L9.52581 9.69284H10.0692C10.4333 9.69284 10.7498 9.49277 10.9156 9.15867C11.0815 8.82457 11.0548 8.44218 10.8432 8.13568L7.18752 2.85513V10.6094H6.30101V0L11.5648 7.6025C11.968 8.18397 12.0214 8.94087 11.7049 9.57753C11.3884 10.2142 10.7622 10.6094 10.0701 10.6094H8.07498V7.60841H8.07403Z",
    fill: "url(#paint2_linear_10011_7977)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10011_7977",
    x1: 5.9996,
    y1: -0.0546994,
    x2: 5.9996,
    y2: 11.9478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB4BE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988649,
    stopColor: "#6B318B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10011_7977",
    x1: 5.9996,
    y1: -0.0546994,
    x2: 5.9996,
    y2: 11.9478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB4BE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988649,
    stopColor: "#6B318B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10011_7977",
    x1: 5.9996,
    y1: -0.0546994,
    x2: 5.9996,
    y2: 11.9478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB4BE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988649,
    stopColor: "#6B318B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10011_7977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.cf65899d4a203c7de5d67ff112863ff9.svg";
export { ForwardRef as ReactComponent };